import * as materials from "materials/legacy/legacy-simple";
export { materials };
export default materials;
